export enum EWebsocketClientEvents {
  WsClientError = 'WsClientError',
  WsClientOpen = 'WsClientOpen',
  WsClientClosed = 'WsClientClosed',
  WsClientReconnected = 'WsClientReconnected',
  // Fired once when auto-reconnect exhausts its attempts and stops retrying (AVS-4330). The
  // session layer uses it to flip to a degraded slow-poll read-repair fallback.
  WsClientGaveUp = 'WsClientGaveUp',
}

export enum EConnectionEvents {
  HandshakeStart = 'HandshakeStart',
  HandshakeComplete = 'HandshakeComplete',
  ConnectionRemoved = 'ConnectionRemoved',
  ConnectionAdded = 'ConnectionAdded',
  Ping = 'Ping',
}

export enum ERTCEvents {
  PeerSignal = 'PeerSignal',
  StreamUpdate = 'StreamUpdate',
}

export enum EStreamSessionEvents {
  SessionUpdated = 'SessionUpdated',
}

// Experience sync events for real-time UI state synchronization (bypasses session/DB)
export enum EExperienceSyncEvents {
  /** Sync data received from peer */
  SyncData = 'ExperienceSyncData',
  /** Full state snapshot (used for initial sync when customer joins) */
  SyncSnapshot = 'ExperienceSyncSnapshot',
  /** Request full state from dealer (customer -> dealer) */
  RequestSnapshot = 'ExperienceSyncRequestSnapshot',
}

export type TAllEvents =
  | EWebsocketClientEvents
  | EConnectionEvents
  | ERTCEvents
  | EStreamSessionEvents
  | EExperienceSyncEvents;

export type TWebSocketMessage = {
  action: EConnectionEvents | ERTCEvents | EStreamSessionEvents | EExperienceSyncEvents;
  from?: string;
  to?: string[];
  data: Record<string, unknown> | RTCSessionDescriptionInit | RTCIceCandidate;
};
